module.exports = __webpack_public_path__ + "static/media/saudiaAqaria.cae9f2b2.webp";